import { useTranslation } from 'react-i18next';
import { Link, useLocation } from 'react-router';
import { useFeature } from '@hero/web-context';
import { route } from '@hero/web-hooks';

const Unauthorized = () => {
  const { t } = useTranslation(['c-main']);
  const location = useLocation();
  const from = (location.state as { from?: { pathname?: string } })?.from?.pathname || '/dashboard';
  const { isEnabled: canSignIn } = useFeature('auth_module', 'sub_sign_in');
  const { isEnabled: canNewSignUp } = useFeature('auth_module', 'sub_new_sign_up');
  const canGoToAuth = canSignIn || canNewSignUp;

  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] p-4 text-center">
      <img src="/images/unauthorized.svg" alt="Unauthorized" className="w-64 h-64 mb-6" />
      <h2 className="text-2xl font-bold text-error mb-2">
        {t('auth:unauthorized.title', 'Access Denied')}
      </h2>
      <p className="text-gray-600 mb-6">
        {t('auth:unauthorized.message', 'Please sign in to access this page')}
      </p>
      {canGoToAuth ? (
        <Link
          to={route('auth_register')}
          className="px-6 py-2 bg-logoBlue text-white rounded-[32px] hover:bg-opacity-90 transition-colors">
          {t('auth:unauthorized.signIn', 'Sign In')}
        </Link>
      ) : (
        <p className="max-w-md text-sm text-muted-foreground">
          {t('c-main:auth_gate.entry_disabled_message')}
        </p>
      )}
      <p className="mt-4 text-sm text-gray-500">
        {t('auth:unauthorized.attemptedAccess', 'Attempted to access')}: {from}
      </p>
    </div>
  );
};

export default Unauthorized;
